export default {"src":"/_next/static/media/logo_wheel_right.dbecc384.svg","height":392,"width":241,"blurWidth":0,"blurHeight":0};